import { VetRepository } from "../interfaces";
import { VetRecord } from "../types";
import { InMemoryStore, nextId } from "./store";

export class InMemoryVetRepository implements VetRepository {
  constructor(private store: InMemoryStore) {}

  async list(): Promise<VetRecord[]> {
    return [...this.store.vets];
  }

  async save(vet: Partial<VetRecord> & { id?: string }): Promise<VetRecord> {
    const created: VetRecord = { name: vet.name ?? "", ...vet, id: nextId("vet") };
    this.store.vets.push(created);
    return created;
  }

  async update(vet: VetRecord): Promise<void> {
    const idx = this.store.vets.findIndex((v) => v.id === vet.id);
    if (idx < 0) throw new Error("Failed to find vet to update");
    this.store.vets[idx] = { ...this.store.vets[idx], ...vet };
  }

  async delete(id: string): Promise<void> {
    this.store.vets = this.store.vets.filter((v) => v.id !== id);
  }
}
